export default [
  {
    title: 'Ofertas em destaque',
    subtitle:
      'Tendo esse liberdade, o filiado pode destacar e ordenar a exibição na qual as ofertas das suas lojas são exibidas para o consumidor no aplicativo. Incluindo as ofertas criadas e ordenadas pela rede para essas lojas.',
    permission: 'offers_mobile',
  },
  {
    title: 'Lojas das ofertas no aplicativo',
    subtitle:
      'Ativar essa opção significa que o filiado pode ajustar a visibilidade, nas suas lojas, das ofertas no aplicativo, sendo restrito apenas as lojas do próprio filiado.',
    permission: 'edit_offers_mobile_units',
  },
  {
    title: 'Banners',
    subtitle: 'Ativar essa opção siginifica que o filiado pode ver os banners criados para suas lojas, e também pode criar novos banners para as mesmas.',
    permission: 'banners_mobile',
  },
  {
    title: 'Campanhas',
    subtitle:
      'Disponibilizar essa opção para o filiado significa que o mesmo passa a poder disparar campanhas de push, para os consumidores que já compraram em suas lojas.',
    permission: 'push_campaigns',
  },
  {
    title: 'Encarte',
    subtitle: 'Ativar essa opção siginifica que o filiado pode ver os encartes criados para suas lojas, e também pode criar novos encartes para as mesmas.',
    permission: 'flyers_campaigns',
  },
  {
    title: 'Desempenho aplicativo',
    subtitle: 'Aqui é onde se vê a quantidade de acessos, cadastros realizados, e páginas mais acessadas no aplicativo da rede.',
    alert:
      'O gráfico de cadastros realizados não exibe dados para o filiado, uma vez que o cadastro não está atrelado a uma loja, e sim ao clube como um todo.',
    permission: 'performance_mobile',
  },
]
